import { Checkbox, Col, DatePicker, Form, Row, Select } from "antd";
import MoroccanPhoneInput from "../components/MoroccanPhoneInput";

interface Props {
  form: any;
  dateFormat: string;
  formData: any;
}

export const CommercialisationStep: React.FC<Props> = ({
  form,
  dateFormat,
  formData,
}) => {
  return (
    <Row gutter={16} style={{ width: "100%" }} justify={"center"}>
      <Col md={10} lg={10} xs={24} sm={24}>
        <Form.Item
          name="contact_agent_commercial"
          label="Contact de l'Agent Commercial"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le contact de l'agent !",
            },
          ]}
        >
          <MoroccanPhoneInput
            value={formData?.contact_agent_commercial}
            onChange={(value) => {
              form.setFieldsValue({ contact_agent_commercial: value });
              formData.contact_agent_commercial = value;
              console.log(formData.contact_agent_commercial);
            }}
          />
        </Form.Item>
        <Form.Item
          name="etat_des_ventes"
          label="État des Ventes"
          rules={[
            {
              required: true,
              message: "Veuillez sélectionner l état des ventes !",
            },
          ]}
        >
          {/* INCONNU = 'inconnu'
            COMMERCIALISATION_NON_INITIIEE = 'commercialisation non initiée'
            COMMERCIALISATION_INITIIEE = 'commercialisation initiée'
            COMMERCIALISATION_ACHEVEE = 'commercialisation achevée' */}
          <Select>
            <Select.Option value="commercialisation non initiée">
              Commercialisation non initiée
            </Select.Option>
            <Select.Option value="commercialisation initiée">
              Commercialisation initiée
            </Select.Option>
            <Select.Option value="commercialisation achevée">
              Commercialisation achevée
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="pratique_noir"
          label="Practique Noire"
          rules={[
            {
              required: true,
              message: "Veuillez sélectionner Practique Noire !",
            },
          ]}
        >
          <Select>
            <Select.Option value={true}>Oui</Select.Option>
            <Select.Option value={false}>Non</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col md={10} lg={10} xs={24} sm={24}>
        {(formData.etat_des_ventes === "commercialisation initiée" ||
          formData.etat_des_ventes === "commercialisation achevée") && (
            <>
             <Form.Item
            name="date_debut_commercialisation"
            label="Début de Commercialisation"
            rules={[
              {
                required: true,
                message:
                  "Veuillez sélectionner la date de début de commercialisation !",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const endDate = getFieldValue("date_fin_commercialisation");
                  if (value && endDate && value.isAfter(endDate)) {
                    return Promise.reject(
                      new Error(
                        "La date de début doit être antérieure à la date de fin !"
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker style={{ width: "100%" }} format={dateFormat} />
          </Form.Item>
             <Form.Item
            name="date_fin_commercialisation"
            label="Fin de Commercialisation"
            rules={[
              {
                required: formData.etat_des_ventes === "commercialisation achevée",
                message:
                  "Veuillez sélectionner la date de fin de commercialisation !",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue(
                    "date_debut_commercialisation"
                  );
                  if (value && startDate && value.isBefore(startDate)) {
                    return Promise.reject(
                      new Error(
                        "La date de fin doit être postérieure à la date de début !"
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker style={{ width: "100%" }} format={dateFormat} />
          </Form.Item>
            </>
         
        )}
        
         
       

        <Form.Item
          name="livraison_immediate"
          label="livraison immédiate ?"
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>
        {formData.livraison_immediate === false && (
          <Form.Item
            name="date_livraison"
            label="Date de Livraison"
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner la date de livraison !",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} format={dateFormat} />
          </Form.Item>
        )}
      </Col>
    </Row>
  );
};
